/**
 * Normalize permission identifier strings from login/API (HTML entities, whitespace).
 * e.g. `Secretary.sd&amp;ed.dashboard` → `Secretary.sd&ed.dashboard`
 */
export function normalizePermissionIdentifier(raw: string): string {
	return String(raw).trim().replace(/&amp;/gi, "&");
}

/**
 * Coerce permissions from login/API to string identifiers.
 * Handles `string[]` or objects with `identifier`, `permission`, or `code`.
 */
export function coercePermissionIdentifiersList(raw: unknown): string[] {
	if (raw == null) return [];
	if (!Array.isArray(raw)) return [];
	const out: string[] = [];
	for (const item of raw) {
		if (typeof item === "string") {
			const n = normalizePermissionIdentifier(item);
			if (n) out.push(n);
		} else if (item !== null && typeof item === "object") {
			const o = item as Record<string, unknown>;
			const id =
				(typeof o.identifier === "string" && o.identifier) ||
				(typeof o.permission === "string" && o.permission) ||
				(typeof o.code === "string" && o.code) ||
				"";
			if (id) out.push(normalizePermissionIdentifier(id));
		}
	}
	return out;
}

/** Whether the user's permission list contains an identifier (after normalizing both sides). */
export function permissionListIncludes(userPermissions: string[], permission: string): boolean {
	const want = normalizePermissionIdentifier(permission);
	return userPermissions.some(up => normalizePermissionIdentifier(up) === want);
}
